import { useReducer } from 'react';
import { ConstantValues } from '../../utils/extensions/constantEx'

const NewServiceFormInitalState = {
    patientName: '',
    patientMobileNo: '',
    patientPlace: '',
    patientAddress: '',
    patientAddressId: ConstantValues.DefaultContactAddressId,
    patientBusRoute: '',
    patientPhone1: '',
    patientPhone2: '',
    deliveryNo: 0,
    selectedServiceType: null,
    serviceStartDate: null,
    serviceDutyDays: 0,
    serviceTotalFee: 0,
    nurseSalary: 0,
    serviceRemarks: '',
    patientFamilies: [],
    patientDocuments: [],
    removedPatientDocIds: [],
    removedDocIds: []
};

const ChangeNurseFormInitalState = {
    serviceId: 0,
    currentServiceNurseId: 0,
    currentNurseCompletedDate: null,
    currentNurseCompletedDays: 0,
    currentNurseCompletedDaysSalary: 0,
    newNurseId: 0,
    newNurseDutyDays: 0,
    newNurseStartDate: null,
    newNurseSalary: 0
}

// const ChangeNurseFormInitalState = {
//     service_id: '',
//     current_service_nurse_id: '',
//     current_nurse_completed_date: '',
//     current_nurse_completed_days: '',
//     current_nurse_completed_days_salary: '',
//     new_nurse_nurse_id: '',
//     new_nurse_duty_days: '',
//     new_nurse_start_date: 0,
//     new_nurse_salary: null
// }


export const ServiceFormInitalState = {
    serviceTypes: [],
    isPageLoadingOpen: false,
    isShowValidationMsgs: false,
    selectedNurse: null,
    selectedPatientService: null,
    isPaymentFormOpen: false,
    patientServiceNewFormValues: { ...NewServiceFormInitalState },
    changeNurseFormInitalState: { ...ChangeNurseFormInitalState }
};

export const ServiceFormReducer = (state = ServiceFormInitalState, action) => {

    switch (action.type) {
        case "SET_SERVICE_TYPES":
            return {
                ...state,
                serviceTypes: action.payload.serviceTypes
            }

        case "SET_SELECTED_PATIENT_SERIVCE":
            return {
                ...state,
                selectedPatientService: action.payload.selectedService
            }

        case "SET_PAGE_LOADING":
            return {
                ...state,
                isPageLoadingOpen: action.payload.isOpen
            }

        case "SET_SELECTED_NURSE":
            return {
                ...state,
                selectedNurse: action.payload.selectedNurse
            }

        case "SET_NEW_FORM_VALUES":
            return {
                ...state,
                patientServiceNewFormValues: action.payload.formValues
            }

        case "SET_CHANGE_NURSE_FORM_VALUES":
            return {
                ...state,
                changeNurseFormInitalState: action.payload.formValues
            }

        case "SET_SHOW_VALIDATION_MESSAGE":
            return {
                ...state,
                isShowValidationMsgs: action.payload.isShowMsgs
            }

        case "SET_SHOW_PAYMENT_FORM":
            return {
                ...state,
                isPaymentFormOpen: action.payload.isPaymentFormOpen
            }

        default:
            return { ...state };

    }
}


export const useServiceForm = () => {
    const [serviceFormState, dispatchServiceFormState] = useReducer(ServiceFormReducer, ServiceFormInitalState);

    const SetServiceTypes = (serviceTypes) => {
        dispatchServiceFormState({
            type: "SET_SERVICE_TYPES",
            payload: {
                serviceTypes: serviceTypes
            }
        })
    }

    const SetSelectedPatientService = (selectedService) => {
        dispatchServiceFormState({
            type: "SET_SELECTED_PATIENT_SERIVCE",
            payload: {
                selectedService: selectedService
            }
        })
    }

    const SetPageLoading = (isOpen) => {
        dispatchServiceFormState({
            type: "SET_PAGE_LOADING",
            payload: {
                isOpen: isOpen
            }
        })
    }

    const SetSelectedNurse = (selectedNurse) => {
        dispatchServiceFormState({
            type: "SET_SELECTED_NURSE",
            payload: {
                selectedNurse: selectedNurse
            }
        })
    }

    const SetNewFormValues = (formValues) => {
        dispatchServiceFormState({
            type: "SET_NEW_FORM_VALUES",
            payload: {
                formValues: formValues
            }
        })
    }

    const SetChangeNurseFormValues = (formValues) => {
        dispatchServiceFormState({
            type: "SET_CHANGE_NURSE_FORM_VALUES",
            payload: {
                formValues: formValues
            }
        })
    }


    const SetIsShowValidationMsgs = (isShow) => {
        dispatchServiceFormState({
            type: "SET_SHOW_VALIDATION_MESSAGE",
            payload: {
                isShowMsgs: isShow
            }
        })
    }

    const SetIsShowPaymentForm = (isOpenForm) => {
        dispatchServiceFormState({
            type: "SET_SHOW_PAYMENT_FORM",
            payload: {
                isPaymentFormOpen: isOpenForm
            }
        })
    }


    return {
        ...serviceFormState,
        SetServiceTypes,
        SetSelectedPatientService,
        SetPageLoading,
        SetSelectedNurse,
        SetNewFormValues,
        SetChangeNurseFormValues,
        SetIsShowValidationMsgs,
        SetIsShowPaymentForm
    }
}